import React, { FC, useState, useEffect, useCallback } from 'react'
import { withStyles, WithStyles } from '@material-ui/core'
import { getValidPass } from '@utils'
import SliderCaptcha, {
  SuccessType,
  CaptchaType,
} from '@components/SliderCaptcha'
import fork from './img/fork.png'
import hide from './img/hide.png'
import show from './img/show.png'
import AppListDialog, { dataType } from './AppListDialog'
import enterpriseFormStyle from '../Login/styles/EnterpriseFormStyle'
import TextField from '@components/TextField'

export type UnionLabelType = 'enterpriseCode' | 'enterpriseMail' | 'enterpriseWord'
export type OnChangeType = (label: UnionLabelType, value: string) => void
interface IProps extends WithStyles<typeof enterpriseFormStyle> {
  enterpriseCode?: string
  enterpriseMail?: string
  enterpriseWord?: string
  stepOne: boolean
  onChange: (label: string, value: string) => void
  onCaptchaImgLoad: () => void
  checkEnterpriseCode: () => void
  handleCaptchaChange: (event: any) => void
  appListDialogVisible: boolean
  appList: dataType
  onClose: () => void
  onImgClose: () => void
  onSelectApp: (appId: string) => () => void
  dialogTitle: string
  loginLoading: boolean
  onCaptSuccess: (success: SuccessType) => void
  onCaptInit: (captObj: CaptchaType) => void
  slideVisible?: boolean
  onEnterpriseLogin: () => void
}

const EnterpriseLoginForm: FC<IProps> = ({
  stepOne,
  classes,
  slideVisible,
  ...props
}) => {
  const [enterpriseCode, setEnterpriseCode] = useState(props.enterpriseCode || '')
  const [enterpriseMail, setEnterpriseMail] = useState('')
  const [enterpriseWord, setEnterpriseWord] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const onChange = useCallback(
    (label: UnionLabelType) => (event: React.ChangeEvent<HTMLInputElement>) => {
      let value = event.target.value
      switch (label) {
      case 'enterpriseCode':
        setEnterpriseCode(value)
        break
      case 'enterpriseMail':
        value = getValidPass(value)
        setEnterpriseMail(value)
        break
      case 'enterpriseWord':
        setEnterpriseWord(value)
        break
      default:
      }
      props.onChange(label, value)
    },
    [enterpriseCode]
  )

  const onInit = (captObj: CaptchaType) => {
    props.onCaptInit(captObj)
  }

  const onCaptSuccess = (success: SuccessType) => props.onCaptSuccess(success)


  const getEnterpriseCode = () => {
    global.$message('请联系企业管理员获取企业代码')
  }

  const onAccountChange = () => {
    setEnterpriseMail('')
  }

  const togglePasswordShow = () => {
    setShowPassword(!showPassword)
  }

  useEffect(() => {
    setEnterpriseMail('')
    setEnterpriseWord('')
  }, [])

  const isButtonDisabled = enterpriseMail.length === 0 || enterpriseWord.trim().length < 8

  return (
    <>
      {stepOne ? 
        <div>
          <TextField
            label='企业代码'
            placeholder="请输入企业代码"
            inputProps={{
              maxLength: 32,
            }}
            className={classes.textField}
            value={enterpriseCode}
            onChange={onChange('enterpriseCode')}
          />
          <div>
            <div className={classes.enterpriseTip} onClick={getEnterpriseCode}>如何获取企业代码?</div>
            <div
              color="primary"
              onClick={props.checkEnterpriseCode}
              className={classes.loginButtonWrapper}
            >
          下一步
            </div>
          </div>
        </div>
        : 
        <div>
          <form
            className={classes.formContainer}
            noValidate={true}
            autoComplete="off"
          >
            <div className={classes.title}>账号密码</div>
            <div className={classes.titleLine} />
            <div className={classes.accountContainer}>
              <TextField
                label='账号'
                placeholder="请输入员工编号"
                inputProps={{
                  maxLength: 32,
                }}
                className={classes.textField}
                value={enterpriseMail}
                onChange={onChange('enterpriseMail')}
              />
              {enterpriseMail.length ? (
                <div
                  className={classes.icon}
                  onClick={onAccountChange}
                >
                  <img style={{ width: '17.5px', height: '17.5px' }} src={fork} alt="" />
                </div>
              ) : null}
            </div>
            <div className={classes.accountContainer}>
              <TextField
                label='密码'
                placeholder="请输入密码"
                inputProps={{
                  maxLength: 32,
                }}
                className={classes.textField}
                type={showPassword ? 'text' : 'password'}
                value={enterpriseWord}
                onChange={onChange('enterpriseWord')}
              />
              <div
                className={classes.icon}
                onClick={togglePasswordShow}
              >
                <img
                  style={{ width: '17.5px', height: '17.5px' }}
                  src={showPassword ? show : hide}
                />
              </div>
            </div>
            {props.appListDialogVisible && (
              <AppListDialog
                data={props.appList}
                title={props.dialogTitle}
                loading={props.loginLoading}
                handleClose={props.onClose}
                handleSelect={props.onSelectApp}
              />
            )}
            <div style={{ position: 'relative' }}>
              <div
                color="primary"
                onClick={props.onEnterpriseLogin}
                className={`${classes.loginButtonWrapper} ${
                  isButtonDisabled ? classes.btnDisabled : ''
                }`}
              >
          登录
              </div>
              {slideVisible && <div style={{ position: 'absolute', visibility: 'hidden', zIndex: -1 }}>
                <SliderCaptcha
                  loginType={2}
                  onInit={onInit}
                  onSuccess={onCaptSuccess}
                  type="202"
                />
              </div>}
            </div>
          </form>
        </div>
      }
    </>
  )
}

export default withStyles(enterpriseFormStyle)(EnterpriseLoginForm)
